// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"DeviceScreen_buttonsContainer__-GEWQ","button":"DeviceScreen_button__ePXUH"};